<script setup lang="ts">
// Fetch categories from the API with sorting
const { data: categories } = await useFetch('/api/categories', {
  query: { orderBy: 'id' },
})

// Transform categories into the format expected by ULandingCard
const categoryCards = computed(
  () =>
    categories.value?.map((category) => ({
      title: category.name,
      description: category.description,
      icon: category.icon,
      to: `/${category.slug}`,
      target: '_self',
      'data-testid': `newsletter-card-${category.slug}`,
    })) || [],
)

// Add complete title with prefix and specify ogTitle
useSeoMeta({
  title: 'AERO.NOW • Our 5-Minute Daily Aerospace Newsletters',
  ogTitle: 'AERO.NOW • Our 5-Minute Daily Aerospace Newsletters',
  twitterTitle: 'AERO.NOW • Our 5-Minute Daily Aerospace Newsletters',
  description:
    'Subscribe to our free curated newsletters covering different aspects of the aerospace industry',
  twitterDescription:
    'Subscribe to our free curated newsletters covering different aspects of the aerospace industry',
})
</script>

<template>
  <UContainer>
    <UPage>
      <ULandingSection
        description="Subscribe to our free curated newsletters covering different aspects of the aerospace industry"
        icon="i-heroicons-newspaper"
        class="py-8"
      >
        <template #title>
          <span class="uppercase">Our 5-Minute Daily Newsletters</span>
        </template>
        <UPageGrid>
          <ULandingCard
            v-for="(item, index) in categoryCards"
            :key="index"
            v-bind="item"
            class="text-center"
            :data-testid="`newsletter-card-${item.to.substring(1)}`"
          >
            <template #icon>
              <span class="text-2xl">{{
                item.icon.startsWith('i-') ? '' : item.icon
              }}</span>
            </template>
          </ULandingCard>
        </UPageGrid>
      </ULandingSection>
    </UPage>
  </UContainer>
</template>
